<template>
  <v-row class="entsys--official-list px-4 mx-0" data-test="staffMember">
    <div
      v-for="staff in staffs"
      :key="staff.id"
      data-test="staff-div"
      class="marker"
    >
      <div class="d-flex pr-6">
        <div class="mb-0" style="flex-grow: 1">
          <div class="staff-list-name-sect">
            <div class="staff-vertical-line"></div>
            <div class="staff-list-name">
              <b><AppShowPersonName :person="staffDetails(staff)" /></b>
            </div>
          </div>

          <div class="staff-details">
            <slot name="details" v-bind="{ staff }">
              <span v-if="staff.role">{{ staff.role.name }}</span>
              <div v-if="canAdd && staff.expiresAt">
                <small>
                  {{
                    $t(
                      "people:personForm.expires.column.label",
                      "Expires",
                      "Label for expires column in roles"
                    )
                  }}
                  {{
                    $dayjs(staff.expiresAt).isSameOrAfter("2198-01-01", "day")
                      ? $t("common:date.NEVER", "Never")
                      : $dayjs.date(staff.expiresAt)
                  }}
                </small>
              </div>
            </slot>
          </div>
        </div>
        <div class="entsys--official-list-actions">
          <slot name="actions" v-bind="{ item: staff }">
            <v-btn-icon
              v-if="canAdd && canEdit(staff.allowedMutations)"
              size="small"
              class="bg-edit-green"
              data-test="staffEdit"
              :aria-label="$t('common:editButton.alt')"
              @click="$emit('edit', staff)"
            >
              <v-icon size="small" color="white">$edit</v-icon> </v-btn-icon
            ><v-btn-icon
              v-if="!noDelete && canAdd"
              size="small"
              class="bg-remove"
              data-test="staffRemove"
              :aria-label="$t('common:deleteButton.alt')"
              @click="deleteKeyEmit($event, staff)"
              ><v-icon size="small" color="white">$iconTrash</v-icon
              ><v-progress-circular
                v-show="false"
                color="white"
                size="14"
                indeterminate
              />
            </v-btn-icon>
          </slot>
        </div>
      </div>
    </div>
  </v-row>
</template>
<script>
import AppShowPersonName from "@AppShows/person/AppShowPersonName.vue";
export default {
  name: "AppStaffList",
  components: { AppShowPersonName },
  props: {
    staffs: { type: Array, default: () => [] },
    canAdd: { type: Boolean, required: true },
    noEdit: { type: Boolean, default: false },
    canEdit: {
      type: Function,
      default: function () {
        return false;
      }
    },
    noDelete: { type: Boolean, default: false },
    staffObjectKey: { type: String, default: null }
  },
  fragments: { person: AppShowPersonName.fragments.person },
  emits: ["delete", "edit"],
  methods: {
    staffDetails(staff) {
      if (this.staffObjectKey) return staff[this.staffObjectKey];
      return staff?.person ?? staff;
    },
    deleteKeyEmit($event, staff) {
      this.$emit("delete", { evt: $event, value: staff });
    }
  }
};
</script>
<style lang="scss">
.entsys--official-list {
  list-style: none;
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  flex-direction: row;
  width: 100%;

  .entsys--official-list-actions {
    white-space: nowrap;
  }

  .marker {
    margin-bottom: 16px;
    padding-left: 2px;
    width: 30%;
    position: relative;
    @media (max-width: 920px) {
      width: 50%;
    }

    @media (max-width: 597px) {
      width: 100%;
    }
  }

  .staff-list-name-sect {
    min-height: 35px;
    display: flex;

    .staff-vertical-line {
      height: 35px;
      width: 2px;
      background: #1c2f5e;
    }

    .staff-list-name {
      font-size: 17px;
      align-self: center;
      padding-left: 8px;
    }
  }

  .staff-details {
    padding-left: 10px;
  }

  @media (max-width: 599px) {
    flex-direction: column;

    li + li {
      margin-left: initial;
      margin-right: initial;
    }
  }
}
</style>
